/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";

import { getTaskByType } from "../../utils/task";
import Modal, { ModalHeader } from "../Modal";
import Icon from "../Icon";
import { get } from "lodash";
import { Col, Row } from "../ContentLayout";
import DataComponent from "../DataComponent";
import Button from "../Button";
import { getDay } from "../../utils/date";
// import systemAlert from "../../utils/systemAlert";

const employeeTitle = (tasks) => {
  const task = getTaskByType('approval_handover_request')
  let title = <></>
  if (!tasks) {
    title = <>전체 할일</>
  } else if (tasks && tasks.length > 1) {
    title = <>할일 <span className='color-main-100'>{tasks.length}</span>건</>
  } else if (tasks.length === 1) {
    const _target = getTaskByType(get(tasks, '[0].approvalTarget.type'))
    const requestEmployeeName = get(tasks, '[0].approvalTarget.requesterEmployee.name')
    title = `${requestEmployeeName ? requestEmployeeName + '님의' : ''} ${_target ? _target.label : ''}`
  }
  return <><Icon src={task.icon} /> {title} 승인</>
}

const TaskCommonDraftApprovalPopup = (props) => {
  const {
    isOpen,
    close,
    taskSelectedList,
    submit
  } = props

  const [handoverReason, setHandoverReason] = useState("");
  const [date] = useState([getDay(), getDay(-5)]);

  const _submit = () => {
    if (submit) {
      submit({ date, comment: handoverReason, taskSelectedList })
    }
  }

  const _close = () => {
    close()
    setHandoverReason("")
  }


  return (
    <Modal
      size="lg"
      isOpen={!!isOpen}
      close={_close}
    >
      <ModalHeader className="task-handover-modal-header">
        {employeeTitle(taskSelectedList)}
      </ModalHeader>
      <Row>
        <Col sm={16} className="task-handover-modal-right">
          <h4 style={
            {
              padding: "0 0 20px",
              fontWeight: "bold",
              fontSize: "13px",
              lineHeight: "19px",
              color: "#4A5673",
            }
          }>
            지시사항 <small style={{ fontSize: "11px" }}>(없는경우 공백)</small>
          </h4>
          <DataComponent
            field={{ type: 'textarea', label: '지시사항' }}
            value={handoverReason}
            onChange={(e) => setHandoverReason(e.target.value)}
          ></DataComponent>
        </Col>
      </Row>
      <Row>
        <Col sm={16}>
          <div className="pt-20">
            <Button onClick={_close} color={'text'}>취소</Button>
            <Button onClick={_submit}>승인</Button>
          </div>
        </Col>
      </Row>
    </Modal>
  );
};

export default TaskCommonDraftApprovalPopup;
